const acaricidesList = [
    {
        "id": "ilac1",
        "name": "Avirmec",
        "image": "https://www.beykoztarimmarket.com/img/products/avirmec_15.01.2021_85d65c7.jpg",
        "info": "1 Lt"
    },
    {
        "id": "ilac2",
        "name": "Zuum",
        "image": "http://www.yapraktarim.com.tr/Upload/File/2019/7/22/zuum-10-sc-1-600x450.jpg",
        "info": "250 CC"
    },
    {
        "id": "ilac3",
        "name": "Zuum",
        "image": "http://www.yapraktarim.com.tr/Upload/File/2019/7/22/zuum-10-sc-1-600x450.jpg",
        "info": "500 CC"
    },
    {
        "id": "ilac4",
        "name": "Agriver",
        "image": "https://http2.mlstatic.com/D_NQ_NP_831695-MLM40309482236_012020-W.jpg",
        "info": "1 Lt"
    },
    {
        "id": "ilac5",
        "name": "Kotoox",
        "image": "https://korumatarim.com/wp-content/uploads/2019/03/2-84-768x767.png",
        "info": "250 CC"
    },
    {
        "id": "ilac6",
        "name": "Delos",
        "image": "https://hektas.com.tr/wp-content/uploads/2021/07/Delos_en.jpg",
        "info": "250 CC"
    },
    {
        "id": "ilac7",
        "name": "Avirmec",
        "image": "https://www.beykoztarimmarket.com/img/products/avirmec_15.01.2021_85d65c7.jpg",
        "info": "250 CC"
    },
    {
        "id": "ilac8",
        "name": "Enigma",
        "image": "https://mentatarim.com/yukleme/urunler/resim/l/enigma-20-wp.jpg",
        "info": "1 Kg"
    },
    {
        "id": "ilac9",
        "name": "Pyramite",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ2LFGfuy0vIt9duTehTZ2rGEOu5MffEon3WXub9gyJVFHWFrreQu_WvYh9KARmxJdaX70&usqp=CAU",
        "info": "1 Kg"
    },
    {
        "id": "ilac10",
        "name": "Passat",
        "image": "",
        "info": "1 Lt"
    },
    {
        "id": "ilac11",
        "name": "Tazole",
        "image": "https://dogaltrm.com/uploads/images/medium/2020-08-27-TAZOLE.jpg",
        "info": "500 CC"
    },
    {
        "id": "ilac12",
        "name": "Exodia",
        "image": "",
        "info": "500 CC"
    },
    {
        "id": "ilac13",
        "name": "Puzzle",
        "image": "",
        "info": "750 Gr"
    },
    {
        "id": "ilac14",
        "name": "Praxis",
        "image": "",
        "info": "1 Lt"
    },
    {
        "id": "ilac15",
        "name": "Enigma 20 WP",
        "image": "https://mentatarim.com/yukleme/urunler/resim/t/enigma-20-wp.jpg",
        "info": "500 Gr"
    },
    {
        "id": "ilac16",
        "name": "Abamec EC",
        "image": "https://rimacsa.co.cr/wp-content/uploads/2021/05/Amabec-1.8-EC.png",
        "info": "250 CC"
    },
    {
        "id": "ilac17",
        "name": "Kotox 10 SC",
        "image": "https://korumatarim.com/wp-content/uploads/2019/03/2-84-768x767.png",
        "info": "1 Lt"
    },
    {
        "id": "ilac18",
        "name": "Costar",
        "image": "",
        "info": "500 CC"
    },
    {
        "id": "ilac19",
        "name": "Exploder",
        "image": "",
        "info": "300 CC"
    },
    {
        "id": "ilac20",
        "name": "Actinmor",
        "image": "https://www.agrikem.com/images/blog/2021/03/145e102e8ab382c0f14f.jpg",
        "info": "1 Lt"
    },
]

export default acaricidesList; 